module.exports = __webpack_public_path__ + "img/statistics.4b00c370.svg";